import { userRole } from 'constant';
import Cm from 'pages/Home/Cm';
import Dtc from 'pages/Home/Dtc';
import Bo from 'pages/Home/Bo';
import { userData } from 'pages/Login/selectors';
import { useSelector } from 'react-redux';

const Home = () => {
  const { roleUser } = useSelector(userData);
  switch (roleUser) {
    case userRole.CM:
      return <Cm />;
    case userRole.DTC:
      return <Dtc />;
    default:
      return <Bo />;
  }
};

export default Home;
